<template>
	<v-dialog v-model="dialog" max-width="600px" @click:outside="$emit('close')" @keydown.esc="$emit('close')">
		<v-card :disabled="form.busy">
			<v-card-title>
				<!-- <span class="headline">{{ momentDate }}</span> -->
				<v-spacer></v-spacer>
				<v-btn icon @click="$emit('close')">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-form @keyup.native.enter="submit" :value="valid" lazy-validation ref="form">
					<v-row>
						<v-col>
							<v-text-field
								v-model="form.name"
								:error-messages="form.errors.get('name')"
								:rules="nameRules"
								:label="$t('fields.name')"
								prepend-icon="mdi-account"
								autofocus
							/>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field
								v-model="form.email"
								:error-messages="form.errors.get('email')"
								:rules="emailRules"
								:label="$t('fields.email')"
								prepend-icon="mdi-at"
							/>
						</v-col>
					</v-row>

					<v-row no-gutters>
						<v-col cols="2">
							<v-select :items="countryCodes" v-model="form.countryCode" prepend-icon="mdi-cellphone-iphone" />
						</v-col>
						<v-col>
							<v-text-field
								v-model="form.phone"
								:error-messages="form.errors.get('phone')"
								:rules="phoneRules"
								:label="$t('fields.phone')"
							/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" @click="submit" :loading="form.busy">{{ $t('save') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbarSuccess" bottom color="success" left :absolute="true">
			{{ $t('messages.success.save') }}
			<v-btn dark text @click="snackbarSuccess = false">
				{{ $t('close') }}
			</v-btn>
		</v-snackbar>
	</v-dialog>
</template>

<script>
import Form from 'vForm'
export default {
	name: 'CreateUpdateUserDialog',
	props: {
		user: {
			type: Object,
			default: null
		},
		closeOnSubmit: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			form: new Form({
				name: null,
				email: null,
				phone: null,
				countryCode: 420
			}),
			dialog: true,
			snackbarSuccess: false,
			countryCodes: [420, 421],
			valid: true,
			emailRules: [v => /.+@.+\..{2,}/.test(v) || !v || this.$t('validation.email_must_be_valid')],
			nameRules: [
				v => !!v || this.$t('validation.field_is_required', { field: this.$t('fields.email') }),
				v => (v || '').length <= 50 || this.$t('max_char', { charCount: '50' })
			]
		}
	},

	created() {
		if (this.user) {
			this.form.name = this.user.name
			this.form.email = this.user.email
			if (this.user.phone) this.form.countryCode = parseInt(this.user.phone.substr(0, 3))
			if (this.user.phone) this.form.phone = this.user.phone.substr(3)
		}
	},

	computed: {
		phoneRules() {
			if (this.form.countryCode === 420) return [v => RegExp(this.$cfg('phonePatterns.cz')).test(v) || !v || this.$t('phone_must_be_valid')]
			if (this.form.countryCode === 421) return [v => RegExp(this.$cfg('phonePatterns.sk')).test(v) || !v || this.$t('phone_must_be_valid')]
			return [true]
		}
	},

	methods: {
		submit() {
			this.valid = this.$refs.form.validate()

			if (this.valid) {
				if (this.user) {
					this.update()
				} else {
					this.create()
				}
			}
		},
		async create() {
			try {
				let { data } = await this.form.post('user')

				if (this.closeOnSubmit) {
					this.$emit('user', data)
					this.$emit('close')
				} else {
					this.snackbarSuccess = true
					this.form.reset()
					this.$refs.form.resetValidation()
				}
			} catch ({ response }) {
				null
			}
		},
		async update() {
			try {
				let { data } = await this.form.put('user/' + this.user.id)
				this.$emit('user', data)
				this.$emit('close')
				this.$refs.form.resetValidation()
			} catch ({ response }) {
				null
			}
		}
	}
}
</script>

<style lang="scss" scoped></style>
